import { Link, useLocation } from 'react-router-dom'
import { Music2, PlaySquare, Music } from 'lucide-react'

const SERVICES = [
    { to: '/tiktoksellpage', label: 'TikTok', Icon: Music2 },
    { to: '/youtube', label: 'YouTube', Icon: PlaySquare },
    { to: '/spotify', label: 'Spotify', Icon: Music },
]

export default function ServicesNav({ dark = true }: { dark?: boolean }) {
    const { pathname } = useLocation()
    const baseText = dark ? 'text-white/70' : 'text-slate-700'
    const activeText = dark ? 'text-white' : 'text-slate-900'
    const border = dark ? 'border-white/10' : 'border-slate-200'
    const bg = dark ? 'bg-black/40 backdrop-blur' : 'bg-white'

    return (
        <nav className={`sticky top-0 z-30 w-full border-b ${border} ${bg}`}>
            <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 md:px-8">
                <Link to="/" className="flex items-center gap-2">
                    <img src="/images/logo.png" alt="TokReach" className="h-8 w-auto" />
                </Link>
                <div className="flex items-center gap-1 sm:gap-2">
                    {SERVICES.map(({ to, label, Icon }) => {
                        const active = pathname === to
                        return (
                            <Link
                                key={to}
                                to={to}
                                className={`inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-xs font-semibold transition sm:text-sm ${
                                    active
                                        ? `${activeText} ${dark ? 'bg-white/10' : 'bg-slate-100'}`
                                        : `${baseText} hover:${activeText} ${
                                              dark ? 'hover:bg-white/5' : 'hover:bg-slate-50'
                                          }`
                                }`}
                            >
                                <Icon className="h-4 w-4" />
                                <span>{label}</span>
                            </Link>
                        )
                    })}
                </div>
            </div>
        </nav>
    )
}
